// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sprite{height:1em;image-rendering:pixelated;margin:2px}`, "",{"version":3,"sources":["webpack://./src/components/Sprite.scss"],"names":[],"mappings":"AAEA,QACI,UAAA,CACA,yBAAA,CACA,UAAA","sourcesContent":["\r\n\r\n.sprite {\r\n    height: 1em;\r\n    image-rendering: pixelated;\r\n    margin: 2px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
